import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowUpRight, FiGlobe, FiSearch, FiMessageCircle} = FiIcons;

const benefits = [
  {
    icon: FiGlobe,
    title: 'Made for your business',
    description: 'A professional custom website that gives customers a clear place to learn about your services.'
  },
  {
    icon: FiSearch,
    title: 'Built with SEO in mind',
    description: 'Search-friendly structure and content help people discover what you offer.'
  },
  {
    icon: FiMessageCircle,
    title: 'Ready for AEO',
    description: 'Clear answers and organized information help answer engines understand your business.'
  }
];

export default function WebsiteFeature({onPricingPage = false}) {
  return (
    <section className="bg-[#142033] py-20 text-white sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#a7e2be]">
              More than a local listing
            </p>
            <h2 className="mt-4 text-4xl font-black leading-tight tracking-tight sm:text-5xl">
              Your business deserves a website built to be found.
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-300">
              We also create a professional custom website for your business, built with SEO and AEO in mind. It gives customers—and answer engines—a better way to understand what you do.
            </p>
            {!onPricingPage && (
              <Link to="/pricing" className="site-button mt-8 inline-flex items-center gap-2 rounded-full px-7 py-4 font-bold">
                See the plan <SafeIcon icon={FiArrowUpRight} />
              </Link>
            )}
          </div>
          <div className="grid gap-4 sm:grid-cols-3 lg:grid-cols-1">
            {benefits.map((benefit) => (
              <div key={benefit.title} className="flex gap-4 rounded-2xl border border-white/10 bg-[#19283d] p-6">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#a7e2be] text-[#0b1423]">
                  <SafeIcon icon={benefit.icon} className="h-6 w-6" />
                </span>
                <div>
                  <h3 className="font-bold text-white">{benefit.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}